import * as React from 'react';
import { Layout } from 'ui/organisms';

export const AnnouncementsLayout: React.FC<{ title?: string }> = ({ children, title }) => {
  return <Layout title={title}>{children}</Layout>;
};
